import React from "react";
import { ChevronRight } from "lucide-react";
import type { PrioritizedIssue } from "../hooks/useMCPContext";

const PRIORITY_COLOR: Record<string, string> = {
  HIGH: "#EF4444",
  MEDIUM: "#F59E0B",
  LOW: "#22C55E",
};

const PRIORITY_LABEL: Record<string, string> = {
  HIGH: "High",
  MEDIUM: "Medium",
  LOW: "Low",
};

interface QuickFixButtonProps {
  issue: PrioritizedIssue;
  onClick: () => void;
  disabled?: boolean;
}

const QuickFixButton: React.FC<QuickFixButtonProps> = ({ issue, onClick, disabled }) => {
  const color = PRIORITY_COLOR[issue.priority] || PRIORITY_COLOR.MEDIUM;
  const label = PRIORITY_LABEL[issue.priority] || "Medium";

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="flex w-full items-center gap-2.5 rounded-[11px] border border-white/[0.07] bg-og01-card px-3.5 py-3 text-left transition-colors hover:border-white/[0.12] hover:bg-og01-card-hover disabled:opacity-50"
    >
      <span className="h-2 w-2 flex-none rounded-full" style={{ background: color }} />
      <div className="min-w-0 flex-1">
        <div className="text-[13.5px] font-medium text-og01-text truncate">{issue.title}</div>
        <div className="mt-0.5 text-[11.5px] text-og01-text-muted">
          {label}
          {issue.timeEstimate ? ` · ${issue.timeEstimate}` : ""}
        </div>
      </div>
      <ChevronRight className="h-[15px] w-[15px] flex-none text-og01-text-muted" />
    </button>
  );
};

export default QuickFixButton;
